import {
    MONTAGE_FORM_LOADING,
    MONTAGE_FORM_DATA,
    MONTAGE_FORM_FAILED,
    MONTAGE_ENUMS_LOADING,
    MONTAGE_ENUMS_DATA,
    MONTAGE_ENUMS_FAILED,
    MONTAGE_FORM_ID_UPDATE,
} from './actions'
import { IMontageState } from './interfaces'

const initialState: IMontageState = {
  form: {
    data: null,
    isLoading: false,
    error: '',
  },
  enums: {
    data: null,
    isLoading: false,
    error: '',
  },
  redirectUrl: undefined
}

export const montageReducer = (
    state = initialState,
    {type, payload},
) => {
  switch (type) {
    case MONTAGE_FORM_LOADING:
      return {
        ...state,
        id: null,
        form: {
          ...state['form'],
          isLoading: true,
          data: null,
          error: ''
        }
      }
    case MONTAGE_FORM_DATA:
      return {
        ...state,
        form: {
          ...state['form'],
          isLoading: false,
          data: payload,
          error: ''
        }
      }
    case MONTAGE_FORM_FAILED:
      return {
        ...state,
        form: {
          ...state['form'],
          isLoading: false,
          error: payload
        }
      }
    case MONTAGE_FORM_ID_UPDATE:
      return {
        ...state,
        id: payload,
      }
    case MONTAGE_ENUMS_LOADING:
      return {
        ...state,
        enums: {
          ...state['enums'],
          isLoading: true,
          data: null,
          error: ''
        }
      }
    case MONTAGE_ENUMS_DATA:
      return {
        ...state,
        enums: {
          ...state['enums'],
          isLoading: false,
          data: payload,
          error: ''
        }
      }
    case MONTAGE_ENUMS_FAILED:
      return {
        ...state,
        enums: {
          ...state['enums'],
          isLoading: false,
          error: payload
        }
      }
    default:
      return state
  }
}
